<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Provedores</h1>

    <SGPMainTabComponent>
      <SGPTabComponent title="Ativos">
        <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

        <SGPTabelaAvancadaComponent
          v-if="listaDeProvedores.length"
          :colunas="colunas"
          :dados="listaDeProvedores"
          :key="'ativos-' + JSON.stringify(listaDeProvedores)"
          @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
          @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
          @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
          selecionarColunas
          :filtroText="true"
          :usuarioPodeRestaurar="false"
        >
          <template v-slot:item.recebe_integracao="{ item }">
            {{ item.recebe_integracao ? 'Sim' : 'Não' }}
          </template>
        </SGPTabelaAvancadaComponent>

        <SGPAlertaComponent v-else></SGPAlertaComponent>
      </SGPTabComponent>

      <SGPTabComponent title="Desativados">
        <SGPTabelaAvancadaComponent
          v-if="listaDeProvedoresDeletados.length"
          :colunas="colunas"
          :dados="listaDeProvedoresDeletados"
          :key="'deletados-' + JSON.stringify(listaDeProvedoresDeletados)"
          @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
          @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado"
          selecionarColunas
          :filtroText="true"
          :usuarioPodeEditar="false"
          :usuarioPodeExcluir="false"
        >
          <template v-slot:item.recebe_integracao="{ item }">
            {{ item.recebe_integracao ? 'Sim' : 'Não' }}
          </template>
        </SGPTabelaAvancadaComponent>

        <SGPAlertaComponent v-else>Nenhum provedor desativado.</SGPAlertaComponent>
      </SGPTabComponent>

      <SGPTabComponent v-if="ehModuloRecuperacao" title="Vincular designações">
        <SGPTabelaAvancadaComponent
          v-if="listaDeProvedores.length"
          :colunas="colunasVinculo"
          :dados="listaDeProvedores"
          :key="'vinculo-' + JSON.stringify(listaDeProvedores)"
          selecionarColunas
          :filtroText="true"
          :somenteLeitura="true"
          :usuarioPodeEditar="false"
          :usuarioPodeExcluir="false"
          :usuarioPodeRestaurar="false"
        >
          <template v-slot:item.vincular="{ item }">
            <SGPFormBotaoComponent
              fab
              rounded
              color="info"
              x-small
              @click="abrirVinculoDesignacoes(item)"
            >
              <v-icon color="white" small>mdi-link-variant</v-icon>
            </SGPFormBotaoComponent>
          </template>
        </SGPTabelaAvancadaComponent>

        <SGPAlertaComponent v-else></SGPAlertaComponent>
      </SGPTabComponent>

      <SGPTabComponent v-if="ehModuloInstalacao" title="SLA de provedores">
        <SGPTabelaAvancadaComponent
          v-if="listaDeProvedores.length"
          :colunas="colunasSla"
          :dados="listaDeProvedores"
          :key="'sla-' + JSON.stringify(listaDeProvedores)"
          selecionarColunas
          :filtroText="true"
          :somenteLeitura="true"
          :usuarioPodeEditar="false"
          :usuarioPodeExcluir="false"
          :usuarioPodeRestaurar="false"
        >
          <template v-slot:item.editar_sla="{ item }">
            <SGPFormBotaoComponent
              fab
              rounded
              color="info"
              x-small
              @click="abrirSlaProvedor(item)"
            >
              <v-icon color="white" small>mdi-timer-outline</v-icon>
            </SGPFormBotaoComponent>
          </template>
          <template v-slot:item.sla="{ item }">
            <span v-if="item.sla_instalacao && item.sla_instalacao.sla">
              {{ item.sla_instalacao.sla }} min ({{ formatarSlaHoras(item.sla_instalacao.sla) }})
            </span>
            <span v-else>-</span>
          </template>
        </SGPTabelaAvancadaComponent>

        <SGPAlertaComponent v-else></SGPAlertaComponent>
      </SGPTabComponent>
    </SGPMainTabComponent>

    <SGPModalComponent
      v-if="abrirModalSla"
      tamanho="sm"
      :titulo="tituloModalSla"
      @sgpModalFechar="fecharModalSla"
      :mostrarFooter="false"
    >
      <SlaProvedorComponent
        :provedor="provedorSla"
        @fechar="fecharModalSla"
        @salvo="onSlaSalvo"
      />
    </SGPModalComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Provedor"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioProvedorComponent
        :tipoFormulario="tipoFormulario"
        :provedor="provedor"
      />
    </SGPModalComponent>

    <SGPModalComponent
      v-if="abrirModalVinculo"
      tamanho="lg"
      :titulo="tituloModalVinculo"
      @sgpModalFechar="fecharModalVinculo"
      :mostrarFooter="false"
    >
      <VincularDesignacoesProvedorComponent
        :provedor="provedorVinculo"
        @fechar="fecharModalVinculo"
        @salvo="onDesignacoesSalvas"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingProvedores"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { CTRL_MODULOS } from '@/common/boot/Constantes'
import FormularioProvedorComponent from '../components/FormularioCtrlProvedoresComponent.vue'
import VincularDesignacoesProvedorComponent from '../components/VincularDesignacoesProvedorComponent.vue'
import SlaProvedorComponent from '../components/SlaProvedorComponent.vue'
import { formatarSlaHoras } from '../helpers/slaHelper'


export default {
  components: {
    FormularioProvedorComponent,
    VincularDesignacoesProvedorComponent,
    SlaProvedorComponent
  },
  name: 'CtrlProvedoresPage',

  data () {
    return {
      provedoresSelecionados: [],
      abrirModal: false,
      abrirModalVinculo: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      provedor: {},
      provedorVinculo: {},
      abrirModalSla: false,
      provedorSla: {},
    }
  },
  created () {
    this.definirRelacoesListagem(this.ehModuloInstalacao ? ['slaInstalacao'] : []);
    this.listarProvedores();
    this.listarProvedoresDeletados();
  },
  beforeDestroy () {
    this.definirRelacoesListagem([]);
  },
  computed: {
    ...mapGetters('ctrlProvedores', [
      'listaDeProvedores',
      'listaDeProvedoresDeletados',
      'loadingProvedores'
    ]),
    ...mapGetters('ctrlModulos', ['moduloAtivo']),

    ehModuloRecuperacao () {
      return this.moduloAtivo == CTRL_MODULOS.RECUPERACAO
    },

    ehModuloInstalacao () {
      return this.moduloAtivo == CTRL_MODULOS.INSTALACAO
    },

    colunasSla () {
      return [
        { key: 'editar_sla', label: 'SLA', sortable: false },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'uf', label: 'UF', sortable: true },
        { key: 'regional', label: 'Regional', sortable: true },
        { key: 'sla', label: 'SLA atual', sortable: false },
      ]
    },

    tituloModalSla () {
      const nome = this.provedorSla?.nome
      return nome ? `SLA · ${nome}` : 'SLA do provedor'
    },

    colunas () {
      return [
        { key: 'selecionar', label: '', sortable: false },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'responsavel', label: 'Responsável', sortable: true },
        { key: 'email_responsavel', label: 'E-mail', sortable: true },
        { key: 'telefone_responsavel', label: 'Telefone', sortable: false },
        { key: 'regional', label: 'Regional', sortable: true },
        { key: 'uf', label: 'UF', sortable: true },
        { key: 'cm', label: 'CM', sortable: true },
        { key: 'cluster', label: 'Cluster', sortable: true },
        { key: 'grupo_operadora', label: 'Grupo operadora', sortable: true },
        ...(this.ehModuloRecuperacao
          ? [{ key: 'recebe_integracao', label: 'Recebe integração', sortable: true }]
          : []),
      ]
    },

    colunasVinculo () {
      return [
        { key: 'vincular', label: 'Vincular', sortable: false },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'responsavel', label: 'Responsável', sortable: true },
        { key: 'regional', label: 'Regional', sortable: true },
        { key: 'uf', label: 'UF', sortable: true },
        { key: 'cm', label: 'CM', sortable: true },
        { key: 'cluster', label: 'Cluster', sortable: true },
        { key: 'grupo_operadora', label: 'Grupo operadora', sortable: true },
      ]
    },

    tituloModalVinculo () {
      const nome = this.provedorVinculo?.nome
      return nome ? `Vincular designações · ${nome}` : 'Vincular designações'
    }
  },

  methods: {
    ...mapActions('ctrlProvedores',
    [
      'listarProvedores',
      'listarProvedoresDeletados',
      'excluirProvedores',
      'restaurarProvedor',
      'definirRelacoesListagem'
    ]),

    formatarSlaHoras,

    gerenciadorDeSelecionados (selecionados) {
      this.provedoresSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.provedor = this.provedoresSelecionados[0];
      this.abrirModal = true;
    },

    restaurarSelecionado(item){
      this.restaurarProvedor(item.id);
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirProvedores(this.provedoresSelecionados);
      this.deletarDados = false;
    },

    adicionarNovo () {
      this.provedor = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    },

    abrirVinculoDesignacoes (item) {
      this.provedorVinculo = item || {};
      this.abrirModalVinculo = true;
    },

    fecharModalVinculo () {
      this.abrirModalVinculo = false;
      this.provedorVinculo = {};
    },

    onDesignacoesSalvas () {
      this.fecharModalVinculo();
    },

    abrirSlaProvedor (item) {
      this.provedorSla = item || {};
      this.abrirModalSla = true;
    },

    fecharModalSla () {
      this.abrirModalSla = false;
      this.provedorSla = {};
    },

    async onSlaSalvo () {
      this.fecharModalSla();
      await this.listarProvedores();
    },
  }
}
</script>
